export default "__VITE_ASSET__69af9b8a__"